import { render, staticRenderFns } from "./ConfigurationCommunicationView.vue?vue&type=template&id=7d9fc856&scoped=true"
import script from "./ConfigurationCommunicationView.vue?vue&type=script&lang=js"
export * from "./ConfigurationCommunicationView.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationCommunicationView.vue?vue&type=style&index=0&id=7d9fc856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9fc856",
  null
  
)

export default component.exports